// extracted by mini-css-extract-plugin
export var accordion = "faq-module--accordion--39844";
export var accordion_button = "faq-module--accordion_button--8899b";
export var accordion_item = "faq-module--accordion_item--a9d62";
export var accordion_panel = "faq-module--accordion_panel--98e3d";
export var accordion_wrap = "faq-module--accordion_wrap--c680c";
export var blogfaq = "faq-module--blogfaq--d086d";
export var faqTitle = "faq-module--faqTitle--323d9";
export var faq_wrap = "faq-module--faq_wrap--54874";
export var iconFAQ = "faq-module--iconFAQ--fdcc1";